import React from 'react';
import PropTypes from 'prop-types';

export const Title = ({ title }) => <div className="title">{title}</div>;

Title.propTypes = { title: PropTypes.string.isRequired };

Title.displayName = 'Card.Title';

export default Title;
